import axios from "axios";

import Utils, { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { AuditLogEntryDto, parseAuditLogsModel } from "../../audit/model";

import { CustomerUserDetailModel, CustomerUserCreateModel, CustomerUserEditModel } from "./model";

class CustomerUserApi {

    private readonly apiUrl = "/api/customeruser";

    public async detail(id: any): Promise<CustomerUserDetailModel> {
        const response = await axios.get(`${this.apiUrl}/${id}`);
        const model = response.data as CustomerUserDetailModel;
        return this.parseModel(model);
    }

    public async save(customerUser: CustomerUserEditModel): Promise<CustomerUserDetailModel> {
        const response = await axios.put(`${this.apiUrl}/${customerUser.id}`, customerUser);
        const model = response.data as CustomerUserDetailModel;
        return this.parseModel(model);
    }

    public async create(customerUser: CustomerUserCreateModel): Promise<CustomerUserDetailModel> {

        const response = await axios.post(this.apiUrl, customerUser);
        const model = response.data as CustomerUserDetailModel;
        return this.parseModel(model);
    }

    public delete(id: any): Promise<void> {
        return axios.delete(`${this.apiUrl}/${id}`);
    }

    public activate(id: string): Promise<void> {
        return axios.post(`${this.apiUrl}/${id}/activate`);
    }

    public deactivate(id: string): Promise<void> {
        return axios.post(`${this.apiUrl}/${id}/deactivate`);
    }

    public async getAuditLogs(customerId: string, customerUserId: string): Promise<AuditLogEntryDto[] | null> {
        const response = await axios.get(`${this.apiUrl}/${customerId}/auditLogs/${customerUserId}`);
        const result = Utils.CheckResponse<ServerModelWithDateStrings<AuditLogEntryDto[]>>(response.data);

        if (!result)
        {
            return null;
        }

        return result.map(parseAuditLogsModel);
    }

    public parseModel(model: CustomerUserDetailModel): CustomerUserDetailModel {
        return {
            ...model
        };
    }
}

export const customerUserApi = new CustomerUserApi();
